import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { width, height } from 'styled-system';
import styled from '@emotion/styled';
import noop from 'lodash/noop';
import { Flex, Box, Icon, NakedButton, Text } from '@qga/roo-ui/components';

const ActionText = styled(Text)`
  text-decoration: underline;
`;

// TODO Remove this once @qga/roo-ui's Icon implementation supports responsive sizes
// See https://github.com/hooroo/@qga/roo-ui/issues/163
const ActionIcon = styled(Icon)`
  ${width};
  ${height};
`;

export default class ExpandableBreakdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.initiallyOpen,
    };
  }

  onToggle = () => {
    const isOpen = !this.state.isOpen;
    this.setState({ isOpen });
    this.props.onToggled(isOpen);
  };

  render() {
    const { toggleText, children, textStyle, iconStyle, onToggled, ...styleProps } = this.props;
    const { isOpen } = this.state;
    return (
      <Fragment>
        <Flex px={5} pb={5} flexDirection={['row-reverse', 'row']} {...styleProps}>
          <NakedButton onClick={this.onToggle}>
            <ActionText fontSize="base" color="greys.steel" {...textStyle}>
              {toggleText}
            </ActionText>
            <ActionIcon width={24} height={24} color="greys.steel" name={isOpen ? 'expandLess' : 'expandMore'} {...iconStyle} />
          </NakedButton>
        </Flex>
        {isOpen && <Box>{children}</Box>}
      </Fragment>
    );
  }
}

ExpandableBreakdown.propTypes = {
  initiallyOpen: PropTypes.bool,
  toggleText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  textStyle: PropTypes.object,
  iconStyle: PropTypes.object,
  onToggle: PropTypes.func,
};

ExpandableBreakdown.defaultProps = {
  initiallyOpen: false,
  textStyle: {},
  iconStyle: {},
  onToggled: noop,
};
